<template>
  <div class="volver">
    <button class="asd" @click="goBack">
      <img src="./../../assets/images/LuqueFlechaIzquierda.svg" alt="" />
      <p class="p-botones">Volver</p>
    </button>
    <div v-if="this.derecha">
      <router-link v-if="derecha" :to="derecha">
        <div class="asd">
          <img src="./../../assets/images/LuqueFlechaDerecha.svg" alt="" />
          <p class="p-botones">Siguiente</p>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { popStep } from "@/router/navigationStack";

export default {
  name: "FlechasComponent",
  props: {
    izquierda: String,
    derecha: String,
    tituloDerecha: String,
    tituloIzquierda: String,
    forceTo: String,
  },
  methods: {
    goBack() {
      if (this.forceTo) return this.$router.push(this.forceTo);
      if (this.izquierda) return this.$router.push(this.izquierda);

      const prev = popStep();
      this.$router.push(prev);
    },
  },
};
</script>

<style scoped>
.volver {
  width: 66vw;
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-top: var(--margin60);
  margin-bottom: var(--gap30);
}
img {
  width: 4.09vw;

  height: 9.182vh;
}
a {
  text-decoration: none;
}
p {
  color: var(--text-primary);
}
.asd {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--gapH5);
  border: none;
  background: none;
}
.asd img {
  transition: transform 0.25s ease;
}

.asd:hover img {
  transform: translateX(6px);
}

.volver a:first-child .asd:hover img {
  transform: translateX(-6px);
}

@media (max-width: 1360px) {
  .volver {
    width: 90%;
    margin: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-bottom: 60px;
    margin-top: 60px;
  }
}
@media (max-width: 990px) {
  .volver {
    width: 90%;
    margin: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-bottom: 5.008vh;
    margin-top: 5.008vh;
  }
  img {
    width: 6.09vw;
    height: 7.182vh;
  }
}
@media (max-width: 770px) {
  .volver {
    width: 90%;
    margin: auto;
    margin-top: var(--gap30);
    margin-bottom: var(--gap20);
    padding-left: 0px;
  }
  img {
    width: 45px;
    height: 45px;
  }
  .p-botones {
    font-weight: 500 !important;
  }
}

@media (max-width: 460px) {
  img {
    width: 45px;
    height: 45px;
  }
  .asd {
    gap: 5px;
  }
}
</style>
